import { z } from 'zod';
/**
 * A domain as fronts are keyed (P6.7) and block rules name a site (P11.5): a DNS
 * name in lower case, without a wildcard, a port or a trailing dot.
 * `domainOfServerName` turns a `server_name` into one.
 *
 * In a file of its own so `block-rules.ts` can use it without importing `web.ts`,
 * which imports the rules.
 */
export const DomainName = z
    .string()
    .min(1)
    .max(253)
    .regex(/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/, 'a domain name');
//# sourceMappingURL=web-domain.js.map